const ONE_MINUTE = 1000 * 60;
const ONE_HOUR = 1000 * 60 * 60;
const ONE_DAY = ONE_HOUR * 24;
const ONE_MONTH = ONE_DAY * 30;
const ONE_YEAR = ONE_DAY * 365;
const relativeTimeFormatter = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

export const getRelativeTime = (timestamp) => {
  if (!timestamp) return "";

  const timestampDate = new Date(timestamp);
  const now = new Date();
  const diffTimeMillis = timestampDate - now;

  if (Math.abs(diffTimeMillis) < ONE_MINUTE) {
    return "Just now";
  }

  if (Math.abs(diffTimeMillis) < ONE_HOUR) {
    return relativeTimeFormatter.format(
      Math.ceil(diffTimeMillis / ONE_MINUTE),
      "minutes",
    );
  }

  if (Math.abs(diffTimeMillis) < ONE_DAY) {
    return relativeTimeFormatter.format(Math.ceil(diffTimeMillis / ONE_HOUR), "hours");
  }

  if (Math.abs(diffTimeMillis) < ONE_MONTH) {
    return relativeTimeFormatter.format(Math.ceil(diffTimeMillis / ONE_DAY), "days");
  }

  if (Math.abs(diffTimeMillis) < ONE_YEAR) {
    return relativeTimeFormatter.format(Math.ceil(diffTimeMillis / ONE_MONTH), "months");
  }

  return relativeTimeFormatter.format(Math.ceil(diffTimeMillis / ONE_YEAR), "years");
};
